import React from 'react';
import { translate } from 'react-i18next';
import { Col, Row } from 'react-bootstrap';
import Map from '../map/Map';

import { FORMATTER_STYLE, getFormatter } from '../../utils/formatter';
import { has_value } from '../../utils/utility';


export class ProjectBasicInfo extends React.Component {
  render() {
    const { project, i18n, t } = this.props;
    const lang = i18n.language.split('-')[0];
    const marker = project
      ? {
          name: project.name,
          lat: project.latitude ? parseFloat(project.latitude) : null,
          lng: project.longitude ? parseFloat(project.longitude) : null,
        }
      : null;

    return (
      <Row>
        <Col xs={12} sm={5} md={4}>
          <div className="card-header">
            <div className="project-title">{project.name}</div>
          </div>
          <div className="project-type">
            <div className="display-icon">
              <i className="far fa-building" />
            </div>
            <div className="display-group">
              <div className="display-label">{t('type')}</div>
              <div className="display-value">
                {project[`building_type_name_${lang}`]}
              </div>
            </div>
          </div>
          <div className="project-field project-area">
            <div className="display-label">
              {t('total area')} ({t('sq m')})
            </div>
            <div className="display-value">
              {has_value(project.area) ? getFormatter(FORMATTER_STYLE.floatFractionDigit2)(project.area) : '-'}
            </div>
          </div>
          <div className="project-field project-area">
            <div className="display-label">
              {t('WWR')}
            </div>
            <div className="display-value">
              {has_value(project.WWR) ? getFormatter(FORMATTER_STYLE.floatFractionDigit2)(project.WWR) : '-'}
            </div>
          </div>
          <div className="project-field project-approve-status">
            <div className="display-label">{t('status')}</div>
            <div className="display-value">{t(project.status.toLowerCase())}</div>
          </div>
        </Col>
        <Col xs={12} sm={7} md={8}>
          <div className="project-field">
            <div className="display-project-desc">
              {project.description}
            </div>
          </div>
        </Col>
        <Col xs={12}>
          <Map
            marker={marker}
            onMarkerMoved={(lat, lng) => console.log(lat, lng)}
          />
        </Col>
      </Row>
    );
  }
}

export default translate('translations')(ProjectBasicInfo);



// WEBPACK FOOTER //
// ./src/components/project_detail/ProjectBasicInfo.js